import React from 'react'
import { Breadcrumb } from '@softura/fluentuipackage'
import './Breadcrumb.scss'

interface IProps {
  items?: any,
  maxDisplayedItems?: any,
  className?: any
}

const BreadcrumContainer = ({ items, maxDisplayedItems = '', className = '' }:IProps) => {
  return (
    <Breadcrumb
     className = {`breadcrumb ${className}`}
     items = {items}
     maxDisplayedItems = {maxDisplayedItems}
    />
  )
}

export default BreadcrumContainer
